import type { DeletionSummary, User } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getAllUsers() {
	const response = await axios.get(env.apiUrl + '/admin/list-users')

	return response.data as User[]
}

export async function updateUserPlan(userId: string, plan: string) {
	await axios.put(env.apiUrl + `/admin/users/${userId}/plan`, { plan })
}

export async function makeUserAdmin(userId: string) {
	await axios.put(env.apiUrl + `/admin/users/${userId}/make-admin`)
}

export async function revokeUserAdmin(userId: string) {
	await axios.put(env.apiUrl + `/admin/users/${userId}/revoke-admin`)
}

export async function softDeleteUser(userId: string) {
	await axios.delete(env.apiUrl + `/admin/users/${userId}/soft-delete`)
}

export async function prepareDeletion(userId: string): Promise<DeletionSummary> {
	const { data } = await axios.post<DeletionSummary>(env.apiUrl + '/admin/prepare-deletion', { userId })

	return data
}

export async function deleteUserData(userId: string) {
	await axios.delete(env.apiUrl + `/admin/delete-user-data/${userId}`)
}
